export const ORDERS_INTERNAL_ROOT_PATH = "orders";

export const ORDERS_INTERNAL_HAS_PURCHASED_NIBBLES_IN_X_MONTHS_SUFFIX = "/nibbles/purchased-within";
export const ORDERS_INTERNAL_HAS_PURCHASED_NIBBLES_IN_X_MONTHS_PARAM = "months";
/** orders/nibbles/purchased-within */
export const ORDERS_INTERNAL_HAS_PURCHASED_NIBBLES_IN_X_MONTHS_PATH = `${ORDERS_INTERNAL_ROOT_PATH}${ORDERS_INTERNAL_HAS_PURCHASED_NIBBLES_IN_X_MONTHS_SUFFIX}`;
